
export interface Dictionary {
  'en': any;
}

/**
 * Available languages
 */
export const DICTIONARY: Dictionary | any = {
  en: null
};
